import React from "react"
import { Link } from "react-router-dom"
import {SortIcon} from 'components/Table_SortColumnIcon'

const businessUnitsListColumn = () => {
  return[
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, businessUnit) => (
        <>
          {businessUnit.id}
        </>
      )
    },
    {
      text: "Business Unit",
      dataField: "name",
      sort: true,
      sortCaret: (order) => <SortIcon order={order}/>,
      formatter: (cellContent, businessUnit) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {businessUnit.name}
            </Link>
          </h5>
        </>
      )
    }
  ]
}

export default businessUnitsListColumn
